import { useFieldWarning } from "@/components/save/use-field-warning";
import { importFieldError, type ImportFieldError } from "@/lib/import-field-validation";
import { useProfileMergeStore } from "@/stores/profile-merge-store";

// Layer-2 sibling of useDateFieldWarning: decides when an in-line merge field's
// length/email/phone/website warning shows, and returns the handlers to wire to the input. Timing
// lives in useFieldWarning (blur, or a blocked save's reveal — never mid-keystroke).
// `validate` is false when this value would not be committed (the discarded side, or an unedited
// existing side), so no warning nags on it. Shares the store's reveal flag with the date warnings so
// a single blocked save surfaces every kind of error at once. Pairs with <MergeFieldWarning>.
export function useImportFieldWarning(
  fieldKey: string,
  value: string,
  validate: boolean,
): { error: ImportFieldError | null; onBlur: () => void; onEdit: () => void } {
  const reveal = useProfileMergeStore((s) => s.revealDateErrors);
  return useFieldWarning(validate ? importFieldError(fieldKey, value) : null, reveal);
}
